import React, { useState, setState } from 'react'
import './ChatNameList.css'
import influencers from '../sampleJSON/trending.json'
import ChatNameListCard from './ChatNameListCard';
import SearchIcon from '@mui/icons-material/Search';
export default function ChatNameList() {
    let influarray = influencers.influencers;
    const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive({isActive:!isActive});
  }
    return(
        <>
            <div className='CNL-outerDiv'>
                <div className='CNL-searchbar'>
                    <input className='CNL-searchinput' type='text' placeholder='search'/>
                    <span><SearchIcon/></span>
                </div>
                <div className='CNL-list d-flex flex-column gap-1'>
                    {
                        influarray.map((element) => {
                        return <div className="CNL-card" key={element.id} style={{backgroundColor: isActive ? '#D1B7FF' : '#EBF3FF'}} onClick={handleClick}>
                            <ChatNameListCard Name={element.Name} userName={element.userName} Profile={element.imgUrl}/>
                        </div>
                    })}
                </div> 
            </div>
        </>
    )
}